import { render, staticRenderFns } from "./Conf.vue?vue&type=template&id=97553a7c&scoped=true&"
import script from "./Conf.vue?vue&type=script&lang=js&"
export * from "./Conf.vue?vue&type=script&lang=js&"
import style0 from "./Conf.vue?vue&type=style&index=0&id=97553a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97553a7c",
  null
  
)

export default component.exports